




















import Vue from "vue";
import PageTitle from "@/commons/components/PageTitle.vue";
import releaseNoteCard from "@/features/releaseNote/components/releaseNoteCard.vue";
import releaseListCard from "@/features/releaseNote/components/releaseListCard.vue";

export default Vue.extend({
  components: {
    "page-title": PageTitle,
    "release-note-card": releaseNoteCard,
    "release-list-card": releaseListCard,
  },
});
